import { useLocalStorage } from '@/hooks/useLocalStorage';

export const usePickUpWhereYouLeftOff = () => {
  const [lastChapterOpened, setLastChapterOpened] = useLocalStorage<
    | {
        chapterUUID: string;
        missionDocumentId: string;
      }
    | undefined
  >('lastChapterOpened', undefined);

  return {
    lastChapterOpened,
    setLastChapterOpened,
  };
};
